/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import {
  State, CurrentState, SelectingState, Item,
} from '../menu-list.slice';
import { hasSelectedAll } from './helpers';

export default function addAvailable(state: State, action: PayloadAction<Item[]>): void {
  state.available = [...state.available, ...action.payload];
  if (state.selectingState === SelectingState.allExisting) {
    state.selected = [...state.selected, ...action.payload];
  }
  state.selectingState = hasSelectedAll(state)
    ? SelectingState.allAvailable
    : SelectingState.simple;
  state.current = state.available.length > 0
    ? CurrentState.selecting
    : CurrentState.nothingAvailable;
}
